import gql from 'graphql-tag'
import { RESOURCE_FRAGMENT } from './Organization'

export const EMAIL_INTERNET_ADDRESS_FRAGMENT = gql`
  fragment EmailInternetAddressFragment on EmailInternetAddress {
    name
    email
  }
`

export const IMAP_SETTINGS_FRAGMENT = gql`
  fragment ImapSettingsFragment on ImapSettings {
    imapHost
    imapPassword
    imapPort
    smtpHost
    smtpPort
  }
`

export const EMAIL_ACCOUNT_FRAGMENT = gql`
  fragment EmailAccountFragment on EmailAccount {
    id
    name
    email
    type
    isDisconnected
    account {
      ...AccountFragment
    }
    imapSettings {
      ...ImapSettingsFragment
    }
    otherAccounts {
      ...AccountFragment
    }
  }
`

export const EMAIL_ENVELOPE_FRAGMENT = gql`
  fragment EmailEnvelopeFragment on EmailEnvelope {
    subject
    bcc {
      ...EmailInternetAddressFragment
    }
    cc {
      ...EmailInternetAddressFragment
    }
    from {
      ...EmailInternetAddressFragment
    }
    to {
      ...EmailInternetAddressFragment
    }
  }
  ${EMAIL_INTERNET_ADDRESS_FRAGMENT}
`

export const SAVE_ACCOUNT_RESPONSE_FRAGMENT = gql`
  fragment SaveAccountResponseFragment on SaveAccountResponse {
    ... on EmailAccount {
      id
    }
    ... on ErrorResponse {
      message
    }
  }
`

export const EMAIL_SIGNATURE_FRAGMENT = gql`
  fragment EmailSignatureFragment on EmailSignature {
    id
    name
    signature
    images {
      ...ResourceFragment
    }
  }
  ${RESOURCE_FRAGMENT}
`
